import HomeIcon from '@mui/icons-material/Home';
import StoreIcon from '@mui/icons-material/Store';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import BusinessIcon from '@mui/icons-material/Business';
import MopedIcon from '@mui/icons-material/Moped';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import InventoryIcon from '@mui/icons-material/Inventory';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SearchIcon from '@mui/icons-material/Search';
import { UserType } from '../../../enums/users';
import LabelIcon from '@mui/icons-material/Label';
import { User } from '../../../interfaces/common/authentication';
import SettingsIcon from '@mui/icons-material/Settings';
import ListAltIcon from '@mui/icons-material/ListAlt';
import InboxIcon from '@mui/icons-material/Inbox';
export const drawerWidth = '275px';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SortIcon from '@mui/icons-material/Sort';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { DeliveryDining, MoveDown } from '@mui/icons-material';
import {
  Page,
  user_can_access_home,
  user_has_page_access,
  user_is_admin,
  user_is_driver,
  user_is_merchant,
} from '../../../utils/permissions';
import WebhookIcon from '@mui/icons-material/Webhook';
import APIIntegrations from '../../merchant-components/api-integrations/api-integrations';

export interface MenuDefinitionItem {
  name: string;
  icon: JSX.Element;
  route_substring: string;
  route: string;
  isVisible: (user: User | null) => boolean;
}

const organisation_menu_definition: MenuDefinitionItem[] = [
  {
    name: 'Home',
    icon: <HomeIcon />,
    route_substring: 'home',
    route: 'home',
    isVisible: (user) => user_has_page_access(user, Page.HOME),
  },
  {
    name: 'Orders',
    icon: <InventoryIcon />,
    route_substring: 'order',
    route: 'orders',
    isVisible: (user) => user_has_page_access(user, Page.ORDERS),
  },
  {
    name: 'Pickup Requests',
    icon: <ListAltIcon />,
    route_substring: 'pickup-task',
    route: 'pickup-tasks',
    isVisible: (user) => user_has_page_access(user, Page.PICKUP_TASKS),
  },
  {
    name: 'Delivery Batches',
    icon: <LocalShippingIcon />,
    route_substring: 'delivery-batches',
    route: 'delivery-batches',
    isVisible: (user) => user_has_page_access(user, Page.DELIVERY_BATCHES),
  },
  {
    name: 'Internal Transfers',
    icon: <MoveDown />,
    route_substring: 'internal-transfers',
    route: 'internal-transfers',
    isVisible: (user) => true
  },
  {
    name: 'Customers',
    icon: <EmojiPeopleIcon />,
    route_substring: 'customer',
    route: 'customers',
    isVisible: (user) => user_has_page_access(user, Page.CUSTOMERS),
  },
  {
    name: 'Merchants',
    icon: <BusinessIcon />,
    route_substring: 'merchant',
    route: 'merchants',
    isVisible: (user) => user_has_page_access(user, Page.MERCHANTS),
  },
  {
    name: 'Drivers',
    icon: <MopedIcon />,
    route_substring: 'driver',
    route: 'drivers',
    isVisible: (user) => user_has_page_access(user, Page.DRIVERS),
  },
  {
    name: 'Employees',
    icon: <SupportAgentIcon />,
    route_substring: 'employee',
    route: 'employees',
    isVisible: (user) => user_has_page_access(user, Page.EMPLOYEES),
  },
  {
    name: 'Shelves',
    icon: <SortIcon />,
    route_substring: 'shelves',
    route: 'shelves',
    isVisible: (user) => user_has_page_access(user, Page.SHELVES),
  },
  {
    name: 'Labels',
    icon: <LabelIcon />,
    route_substring: 'label',
    route: 'labels',
    isVisible: (user) => user_has_page_access(user, Page.LABELS),
  },
  {
    name: 'Accounting',
    icon: <AttachMoneyIcon />,
    route_substring: 'accounting',
    route: 'accounting',
    isVisible: (user) => user_has_page_access(user, Page.ACCOUNTING),
  },
  {
    name: 'Settings',
    icon: <SettingsIcon />,
    route_substring: 'settings',
    route: 'settings',
    isVisible: user_is_admin,
  },
];

export const driver_menu_definition: MenuDefinitionItem[] = [
  {
    name: 'Pickup Tasks',
    icon: <InboxIcon />,
    route_substring: 'pickup-tasks',
    route: 'pickup-tasks',
    isVisible: user_is_driver,
  },
  {
    name: 'Delivery Tasks',
    icon: <DeliveryDining />,
    route_substring: 'delivery-batches',
    route: 'delivery-batches',
    isVisible: user_is_driver,
  },
  {
    name: 'Payment Tasks',
    icon: <AttachMoneyIcon />,
    route_substring: 'payment-tasks',
    route: 'payment-tasks',
    isVisible: user_is_driver,
  },
  {
    name: 'My Invoices',
    icon: <ReceiptIcon />,
    route_substring: 'invoice',
    route: 'invoices',
    isVisible: user_is_driver,
  },
];

const merchant_menu_definition: MenuDefinitionItem[] = [
  {
    name: 'Home',
    icon: <HomeIcon />,
    route_substring: 'home',
    route: 'home',
    isVisible: user_is_merchant,
  },
  {
    name: 'My Orders',
    icon: <InventoryIcon />,
    route_substring: 'order',
    route: 'merchant-orders',
    isVisible: user_is_merchant,
  },
  {
    name: 'Pickup Locations',
    icon: <LocationOnIcon />,
    route_substring: 'pickup',
    route: 'merchant-pickups',
    isVisible: user_is_merchant,
  },
  {
    name: 'Pickup Requests',
    icon: <ListAltIcon />,
    route_substring: 'task',
    route: 'merchant-tasks',
    isVisible: user_is_merchant,
  },
  {
    name: 'Customers',
    icon: <EmojiPeopleIcon />,
    route_substring: 'customer',
    route: 'customers',
    isVisible: user_is_merchant,
  },
  {
    name: 'Track Payments',
    icon: <AttachMoneyIcon />,
    route_substring: 'invoice',
    route: 'invoices',
    isVisible: user_is_merchant,
  },
  {
    name: 'API Integrations',
    icon: <WebhookIcon />,
    route_substring: 'api-integration',
    route: 'api-integrations',
    isVisible: user_is_merchant,
  },
  {
    name: 'Settings',
    icon: <SettingsIcon />,
    route_substring: 'settings',
    route: 'settings',
    isVisible: user_is_merchant,
  }
];

export const get_menu_definition = (
  user?: User | null
): MenuDefinitionItem[] => {
  if (!user) return [];
  switch (user.type) {
    case UserType.ORGANISATION: {
      return organisation_menu_definition;
    }
    case UserType.EMPLOYEE: {
      return organisation_menu_definition;
    }
    case UserType.DRIVER: {
      return driver_menu_definition;
    }
    case UserType.MERCHANT: {
      return merchant_menu_definition;
    }
    default: {
      return [];
    }
  }
};
